import React from 'react';
import classnames from 'classnames';

import { Section, Layout, SEO } from '..';

import style from './CareersPage.module.less';

export const CareersPage = () => (
  <Layout>
    <SEO title="Careers" description="Join us!" />

    <Section className={classnames(style.section, style.firstSection)}>
      <div className={classnames(style.header)}>
        <h1>Careers</h1>
      </div>

      <div className={style.row}>
        <div className={style.text}>
          <h2>Currently open positions</h2>

          <p>Unfortunately, we don't have any open positions at the moment. But don't worry, we're always looking for talented people to join our team. If you think you'd be a good fit, send us your CV.</p>

          <h2>Get in touch</h2>

          <p>Don't see an open position that fits your profile? We're always looking for talented people to join our team. If you think you'd be a good fit, send us your CV and portfolio.</p>
          <p>You can reach us at <a href="mailto:careers@elevenpuzzles.com">careers@elevenpuzzles.com</a></p>

          <p>We'll answer as soon as possible, take care!</p>
        </div>
      </div>
    </Section>
  </Layout>
);
